import React, { FC, PropsWithChildren } from 'react';
import { View } from 'react-native';
import { ColorFunction } from '@styles/colors/types';
import ColorWrapper from '@styles/colors';
import { getBoxShadowStyle } from '@styles/shadow';
import { ContainerStyle, SimpleOnPress } from '@interfaces/base';
import { MACHINES_NOW_OVERVIEW_BLOCK_CONFIG } from '@v2/pages/machines/modules/now/components/Overview/constants';
import { SCREEN_BORDER_RADIUS } from '@v2/pages/common/constants/base.constants';
import { scale } from '@components/frame';
import TouchableElement from '@components/common/touchableElement';

interface BlockWrapperProps extends PropsWithChildren, ContainerStyle, Partial<SimpleOnPress> {
  C: ColorFunction;
  testID?: string;
}

const BlockWrapper: FC<BlockWrapperProps> = ({ children, C, containerStyle, onPress, testID }) => {
  const boxShadowStyles = getBoxShadowStyle({ type: 'Field', C });

  const commonStyles = [
    boxShadowStyles,
    {
      backgroundColor: C(MACHINES_NOW_OVERVIEW_BLOCK_CONFIG.blockBgColor),
      borderRadius: scale(SCREEN_BORDER_RADIUS),
      paddingHorizontal: scale(MACHINES_NOW_OVERVIEW_BLOCK_CONFIG.paddingHorizontal),
    },
    containerStyle,
  ];

  if (!onPress) return <View testID={testID} style={commonStyles}>{children}</View>;

  return (
    <TouchableElement testID={testID} onPress={onPress}>
      {({ boxStyle, pressHoverColor }) => {
        return <View
          style={[
            ...commonStyles,
            boxStyle,
            {
              backgroundColor: C(pressHoverColor(MACHINES_NOW_OVERVIEW_BLOCK_CONFIG.blockBgColor)),
            },
          ]}
        >
          {children}
        </View>
      }}
    </TouchableElement>
  );
};

export default ColorWrapper(BlockWrapper);
